/* ===== Donley Sport theme — theme.js ===== */
(function(){
  'use strict';
  var money = function(cents){
    try{ return (cents/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify&&Shopify.currency?Shopify.currency.active:'EUR'}); }
    catch(e){ return '€'+(cents/100).toFixed(2); }
  };
  var esc = function(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]; }); };
  var $ = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------- drawers / overlay ---------- */
  function openEl(el){ if(el){ el.classList.add('is-open'); document.body.style.overflow='hidden'; toggleOverlay(true);} }
  function closeAll(){ $$('.is-open').forEach(function(e){ if(e.classList.contains('cart-drawer')||e.classList.contains('mobile-nav')||e.classList.contains('overlay')||e.classList.contains('qv-modal')) e.classList.remove('is-open'); }); document.body.style.overflow=''; }
  function toggleOverlay(on){ var o=$('.overlay'); if(o) o.classList.toggle('is-open',!!on); }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-cart-toggle],[data-menu-toggle],[data-close],.overlay,[data-quickview],[data-qv-close]');
    if(!t) return;
    if(t.hasAttribute('data-cart-toggle')){ e.preventDefault(); refreshCart().then(function(){ openEl($('.cart-drawer')); }); }
    else if(t.hasAttribute('data-menu-toggle')){ e.preventDefault(); openEl($('.mobile-nav')); }
    else if(t.classList.contains('overlay')||t.hasAttribute('data-close')||t.hasAttribute('data-qv-close')){ closeAll(); }
    else if(t.hasAttribute('data-quickview')){ e.preventDefault(); openQuickView(t.getAttribute('data-quickview')); }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });

  /* ---------- hero slideshow ---------- */
  $$('[data-slideshow]').forEach(function(root){
    var track=$('.hero__slides',root), slides=$$('.hero__slide',root);
    if(slides.length<2) return;
    var dots=$$('.hero__dot',root), i=0, auto=parseInt(root.getAttribute('data-autoplay')||'0',10), timer;
    function go(n){ i=(n+slides.length)%slides.length; track.style.transform='translateX(-'+(i*100)+'%)'; dots.forEach(function(d,x){ d.classList.toggle('is-active',x===i); }); }
    $$('.hero__dot',root).forEach(function(d,x){ d.addEventListener('click',function(){ go(x); reset(); }); });
    var nx=$('.hero__arrow--next',root), pv=$('.hero__arrow--prev',root);
    if(nx) nx.addEventListener('click',function(){ go(i+1); reset(); });
    if(pv) pv.addEventListener('click',function(){ go(i-1); reset(); });
    function reset(){ if(auto){ clearInterval(timer); timer=setInterval(function(){ go(i+1); }, auto); } }
    reset();
  });

  /* ---------- product gallery thumbs ---------- */
  $$('[data-gallery]').forEach(function(g){
    var main=$('[data-gallery-main] img',g);
    $$('[data-thumb]',g).forEach(function(th){
      th.addEventListener('click',function(){
        var full=th.getAttribute('data-full');
        if(main&&full){ main.src=full; main.srcset=''; }
        $$('[data-thumb]',g).forEach(function(t){ t.classList.remove('is-active'); });
        th.classList.add('is-active');
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty-minus],[data-qty-plus]'); if(!b) return;
    var input=b.parentNode.querySelector('input'); if(!input) return;
    var v=parseInt(input.value||'1',10);
    v = b.hasAttribute('data-qty-plus') ? v+1 : Math.max(1,v-1);
    input.value=v; input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  /* ---------- variant selection ---------- */
  function initVariants(form){
    var dataEl=$('[data-variants]',form); if(!dataEl) return;
    var variants=JSON.parse(dataEl.textContent);
    var idInput=$('[name="id"]',form);
    var priceEl=document.querySelector('[data-product-price]');
    var addBtn=$('[data-add-to-cart]',form);
    function selected(){
      var opts=[];
      $$('[data-option-index]',form).forEach(function(group){
        var idx=parseInt(group.getAttribute('data-option-index'),10);
        var checked=group.querySelector('input:checked');
        if(checked) opts[idx]=checked.value;
      });
      return opts;
    }
    function update(){
      var opts=selected();
      var match=opts.length ? variants.find(function(v){ return v.options.every(function(o,x){ return o===opts[x]; }); }) : variants[0];
      if(!match){ if(addBtn){ addBtn.disabled=true; addBtn.textContent=addBtn.getAttribute('data-unavailable')||'Niet beschikbaar'; } return; }
      idInput.value=match.id;
      if(priceEl){ priceEl.innerHTML=renderPrice(match); }
      var eanEl=document.querySelector('[data-product-ean]');
      if(eanEl&&match.barcode){ eanEl.textContent='EAN: '+match.barcode; }
      if(addBtn){
        if(match.available){ addBtn.disabled=false; addBtn.textContent=addBtn.getAttribute('data-add')||'In winkelwagen'; }
        else { addBtn.disabled=true; addBtn.textContent=addBtn.getAttribute('data-soldout')||'Uitverkocht'; }
      }
      if(match.featured_image){
        var main=document.querySelector('[data-gallery-main] img');
        if(main){ main.src=match.featured_image.src; main.srcset=''; }
      }
      $$('.swatch,[data-option-index] label',form).forEach(function(l){ var i=l.querySelector('input'); if(i){ l.classList.toggle('is-active', i.checked); } });
    }
    function renderPrice(v){
      var html='<span class="'+(v.compare_at_price>v.price?'price__sale':'')+'">'+money(v.price)+'</span>';
      if(v.compare_at_price>v.price){ html+=' <span class="price__compare">'+money(v.compare_at_price)+'</span>'; html+=' <span class="price__save">-'+money(v.compare_at_price-v.price)+'</span>'; }
      return html;
    }
    $$('[data-option-index] input',form).forEach(function(inp){ inp.addEventListener('change',update); });
    update();
  }
  $$('[data-product-form]').forEach(initVariants);

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit',function(e){
    var form=e.target.closest('[data-product-form]'); if(!form) return;
    e.preventDefault();
    var btn=$('[data-add-to-cart]',form); var orig=btn?btn.textContent:'';
    if(btn){ btn.disabled=true; btn.textContent='...'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(serialize(form))})
      .then(function(r){ return r.json(); })
      .then(function(){ return refreshCart(); })
      .then(function(){ if(btn){ btn.disabled=false; btn.textContent=orig; } closeAll(); openEl($('.cart-drawer')); })
      .catch(function(){ if(btn){ btn.disabled=false; btn.textContent=orig; } });
  });
  function serialize(form){
    var id=$('[name="id"]',form).value;
    var qtyEl=$('[name="quantity"]',form);
    return { items:[{ id:parseInt(id,10), quantity:qtyEl?parseInt(qtyEl.value,10):1 }] };
  }

  /* ---------- cart drawer refresh & qty/remove ---------- */
  function refreshCart(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(renderCart);
  }
  function renderCart(cart){
    $$('[data-cart-count]').forEach(function(el){ el.textContent=cart.item_count; el.style.display=cart.item_count?'flex':'none'; });
    var wrap=$('[data-cart-items]'); if(!wrap) return cart;
    if(!cart.item_count){
      wrap.innerHTML='<p style="padding:40px 0;text-align:center">'+(wrap.getAttribute('data-empty')||'Je winkelwagen is leeg.')+'</p>';
    } else {
      wrap.innerHTML=cart.items.map(function(it){
        return '<div class="cart-item" data-key="'+esc(it.key)+'">'+
          (it.image?'<img src="'+esc(it.image.replace(/(\.[a-z]+)(\?.*)?$/,'_120x$1'))+'" alt="">':'<span></span>')+
          '<div><a class="cart-item__title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+
          (it.variant_title&&it.variant_title!=='Default Title'?'<div class="cart-item__variant">'+esc(it.variant_title)+'</div>':'')+
          '<div class="qty" style="margin:8px 0 0"><button data-line-minus aria-label="-">&minus;</button><input value="'+parseInt(it.quantity,10)+'" data-line-qty readonly><button data-line-plus aria-label="+">+</button></div></div>'+
          '<div style="text-align:right"><div>'+money(it.final_line_price)+'</div><button class="link-underline" style="font-size:.7rem;margin-top:8px" data-line-remove>Verwijder</button></div>'+
        '</div>';
      }).join('');
    }
    $$('[data-cart-subtotal]').forEach(function(el){ el.textContent=money(cart.total_price); });
    var th=parseInt((document.body.getAttribute('data-free-ship')||'0'),10);
    var prog=$('[data-cart-progress]');
    if(prog&&th>0){
      var fill=$('.cart-progress__fill',prog), msg=$('[data-progress-msg]',prog);
      var pct=Math.min(100,Math.round(cart.total_price/th*100));
      if(fill) fill.style.width=pct+'%';
      if(msg) msg.textContent = cart.total_price>=th ? (prog.getAttribute('data-done')||'Gratis verzending bereikt!') : (prog.getAttribute('data-msg')||'').replace('[amount]',money(th-cart.total_price));
    }
    return cart;
  }
  function changeLine(key,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
  }
  document.addEventListener('click',function(e){
    var row=e.target.closest('[data-key]'); if(!row) return;
    var key=row.getAttribute('data-key');
    var input=row.querySelector('[data-line-qty]'); var q=input?parseInt(input.value,10):1;
    if(e.target.closest('[data-line-plus]')) changeLine(key,q+1);
    else if(e.target.closest('[data-line-minus]')) changeLine(key,Math.max(0,q-1));
    else if(e.target.closest('[data-line-remove]')) changeLine(key,0);
  });

  /* ---------- quick view ---------- */
  function openQuickView(handle){
    var modal=$('#QuickView'); if(!modal) return;
    var box=$('.qv-modal__box',modal); box.innerHTML='<p style="padding:60px;text-align:center">Loading…</p>';
    openEl(modal); modal.classList.add('is-open');
    fetch('/products/'+encodeURIComponent(handle)+'?view=quickview').then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var content=doc.querySelector('[data-quickview-content]');
      box.innerHTML='<button class="qv-close" data-qv-close aria-label="Close">&times;</button>'+(content?content.innerHTML:'<p>Niet beschikbaar</p>');
      $$('[data-product-form]',box).forEach(initVariants);
    }).catch(function(){ box.innerHTML='<button class="qv-close" data-qv-close>&times;</button><p style="padding:40px">Kon product niet laden.</p>'; });
  }

  /* ---------- product recommendations ---------- */
  function loadRecommendations(){
    var el=document.querySelector('[data-rec-url]'); if(!el) return;
    fetch(el.getAttribute('data-rec-url')).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var inner=doc.querySelector('.page-width');
      if(inner && doc.querySelector('.product-grid')){ el.innerHTML=inner.innerHTML; }
    }).catch(function(){});
  }

  /* ---------- product carousel ---------- */
  $$('[data-carousel]').forEach(function(c){
    var track=$('[data-carousel-track]',c);
    var prev=$('[data-carousel-prev]',c), next=$('[data-carousel-next]',c);
    function step(){ var card=track.querySelector('.card'); return card?(card.getBoundingClientRect().width+20)*2:600; }
    if(next) next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
  });

  /* ---------- transparante header (homepage) ---------- */
  (function(){
    var hdr=document.querySelector('.header--overlay');
    if(!hdr) return;
    function onScroll(){ hdr.classList.toggle('is-scrolled', (window.scrollY||document.documentElement.scrollTop)>24); }
    function setAnnH(){ var ann=document.querySelector('.announcement--usp'); if(ann){ document.documentElement.style.setProperty('--ann-h', ann.offsetHeight+'px'); } }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',setAnnH,{passive:true});
    setAnnH(); onScroll();
  })();

  document.addEventListener('DOMContentLoaded',function(){ refreshCart(); loadRecommendations(); });
})();
